import { useContext } from 'react';
import AuthContext from 'src/views/auth/BridgeAuthConnect';
//import AuthContext from 'src/contexts/JWTAuthContext'

const useAuth = () => useContext(AuthContext);

export default useAuth;
